import { render, staticRenderFns } from "./BodyText.vue?vue&type=template&id=0cc98d20&scoped=true&"
import script from "./BodyText.vue?vue&type=script&lang=js&"
export * from "./BodyText.vue?vue&type=script&lang=js&"
import style0 from "./BodyText.vue?vue&type=style&index=0&id=0cc98d20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc98d20",
  null
  
)

export default component.exports